import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Lock, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(email, password);
            navigate("/admin");
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || "Authentication error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-tbv-ink flex items-center justify-center p-6 relative overflow-hidden" data-testid="admin-login-page">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-tbv-green/10 blur-[120px]" />
            <Link to="/" className="absolute top-6 left-6 text-white/60 hover:text-white text-sm flex items-center gap-2" data-testid="back-to-home">
                <ArrowLeft className="w-4 h-4" /> Back to site
            </Link>

            <div className="relative w-full max-w-md">
                <div className="bg-white rounded-3xl p-8 lg:p-10 shadow-2xl">
                    <div className="flex justify-center mb-6">
                        <div className="w-16 h-16 rounded-2xl bg-tbv-ink flex items-center justify-center">
                            <Lock className="w-7 h-7 text-tbv-green" />
                        </div>
                    </div>
                    <h1 className="font-display text-3xl font-bold text-center mb-2">Admin Panel</h1>
                    <p className="text-tbv-soft text-center text-sm mb-8">Three Brothers Vivero</p>

                    <form onSubmit={submit} className="space-y-5">
                        <div>
                            <label className="text-xs uppercase tracking-wider text-tbv-soft font-bold">Email</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                data-testid="admin-login-email"
                                className="mt-2 w-full bg-tbv-bg border border-tbv-border rounded-xl px-4 py-3 focus:outline-none focus:border-tbv-deep transition"
                                placeholder="admin@threebrothersvivero.com"
                            />
                        </div>
                        <div>
                            <label className="text-xs uppercase tracking-wider text-tbv-soft font-bold">Password</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                data-testid="admin-login-password"
                                className="mt-2 w-full bg-tbv-bg border border-tbv-border rounded-xl px-4 py-3 focus:outline-none focus:border-tbv-deep transition"
                                placeholder="••••••••"
                            />
                        </div>
                        {error && (
                            <div className="text-red-600 text-sm bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="admin-login-error">
                                {error}
                            </div>
                        )}
                        <button
                            type="submit"
                            disabled={loading}
                            className="btn-primary w-full justify-center disabled:opacity-60"
                            data-testid="admin-login-submit"
                        >
                            {loading ? "Signing in..." : "Sign In"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
